import React from 'react';
import PropTypes from 'prop-types';
import SMORoomUnavailabilityCalendarCell from './SMORoomUnavailabilityCalendarCell';
import SMORoomExceptionCalendarCell from './SMORoomExceptionCalendarCell';
import SMConst from 'lib/SMConst';

class SMMonthCalendarRow extends React.Component {
  
  render() {
    
    let calendarCells = [],
        column_count = 7;
    for (let i=0; i < this.props.items.length; i++) {
      if (this.props.selectedCalendar == SMConst.CalendarType.Availability) {
        calendarCells.push(<SMORoomUnavailabilityCalendarCell 
          key={'availability-cell-'+i}
          plan={this.props.plan}
          room={this.props.room}
          delegate={this.props.delegate}
          item={this.props.items[i]} 
          today={this.props.today}
        />);
      } else {
        calendarCells.push(<SMORoomExceptionCalendarCell 
          key={'price-cell-'+i}
          plan={this.props.plan}
          room={this.props.room}
          delegate={this.props.delegate}
          item={this.props.items[i]} 
          today={this.props.today}
          selectedCalendar={this.props.selectedCalendar}
        />);
      }
    }
    
    return(
      <tr>
        {calendarCells}
      </tr>
    );
  }
}
SMMonthCalendarRow.propTypes = {
  items: PropTypes.array.isRequired,
  today: PropTypes.instanceOf(Date).isRequired,
  room: PropTypes.object,
  plan: PropTypes.object,
  delegate: PropTypes.object,
  selectedCalendar: PropTypes.number,
};

export default SMMonthCalendarRow;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/calendar/SMMonthCalendarRow.jsx